export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13549.c32294e5.jpg";